import { Container } from "react-bootstrap";
import CategorizedProductCarousel from "../../components/Home/CategorizedProductCarousel";
import NewArrivalsTabs from "../../components/Home/NewArrivalsTabs/NewArrivalsTabs";

import {
  useGetFeaturedProductsQuery,
  useGetNewArrivalsQuery,
  useGetPopularProductsQuery,
  useGetRegularProductsQuery,
} from "../../redux/products/productsApi";
const ShopAll = ({ setShow }) => {
  const {
    data: newArrivals,
    isLoading: newArrivalsLoading,
    isError: newArrivalsError,
  } = useGetNewArrivalsQuery();
  const {
    data: featuredProducts,
    isLoading: featuredProductLoading,
    isError: featuredProductError,
  } = useGetFeaturedProductsQuery();
  const {
    data: popularProducts,
    isLoading: popularProductLoading,
    isError: popularProductError,
  } = useGetPopularProductsQuery();
  const {
    data: regularProducts,
    isLoading: regularProductLoading,
    isError: regularProductError,
  } = useGetRegularProductsQuery();

  return (
    <>
      <Container>
        {" "}
        {
          <CategorizedProductCarousel
            setShow={setShow}
            title={"Featured Products"}
            productList={featuredProducts?.result}
            isLoading={featuredProductLoading}
            isError={featuredProductError}
          />
        }
      </Container>

      <Container>
        {
          // <CategorizedProductCarousel
          //   setShow={setShow}
          //   title={"New Arrivals"}
          //   title2={"Regular Products"}
          //   productList={newArrivals?.result}
          //   productList2={regularProducts?.result}
          //   isLoading={newArrivalsLoading}
          //   isError={newArrivalsError}
          // />
          <NewArrivalsTabs
            setShow={setShow}
            newArrivalsData={newArrivals?.result}
            regularProductsData={regularProducts?.result}
            newArrivalsLoading={newArrivalsLoading}
            newArrivalsError={newArrivalsError}
            regularProductsLoading={regularProductLoading}
            regularProductError={regularProductError}
          />
        }
      </Container>

      <Container>
        {" "}
        {
          <CategorizedProductCarousel
            setShow={setShow}
            title={"Popular Products"}
            productList={popularProducts?.result}
            isLoading={popularProductLoading}
            isError={popularProductError}
          />
        }
      </Container>

      <Container>
        {
          <CategorizedProductCarousel
            setShow={setShow}
            title={"Regular Products"}
            productList={regularProducts?.result}
            isLoading={regularProductLoading}
            isError={regularProductError}
          />
        }
      </Container>
    </>
  );
};
export default ShopAll;
